module.exports = __webpack_public_path__ + "img/stas-main_480.0af0e000.jpg";